require('./hireCardECardStep2.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const {
    ACCOUNT_INTERVENTION_AUTHORIZED,
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    SECOND_STEP,
} = require('constants/index');
const { ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES } = require('constants/accounts');

class hireCardECardStep2 extends React.Component {

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const interventionTypes = [
            ACCOUNT_INTERVENTION_AUTHORIZED,
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];

        const accountsIndexes = immAccounts.get('byOrder').filter( accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter( accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter( accountId =>
            // We remove the accounts where the user doesn't have one of the required intervention types.
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            handleAccountChange,
            immAccounts,
            immHireCardECard,
            immHireCardNameSelector,
            isInactiveAccountsEnabled,
        } = this.props;
        const immStep2 = immHireCardECard.getIn(['steps', SECOND_STEP]);
        const accountErrorMsgVisible = immStep2.get('accountIsDirty') && !immStep2.get('accountId');
        const accountErrorMsg = formatText('hireCardECard-step2SelectAccountError');
        const accountLabel = formatText('hireCardECard-step2SelectAccount');
        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-eCardLinkUrl');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        return (
            <article className="hire-card-ecard-step-two">
                <FormattedText
                    className="hire-card-ecard__step-title"
                    value="hireCardECard-step2Title"
                />
                <HireCardNameSelector
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    currentAccountId={immStep2.get('accountId')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    showAvailableBalance={true}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    loading={isBlockedAccountsLoading}
                />
                <div className="hire-card-ecard-step-two__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText value="disclaimerPersonalInfo-eCardMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-eCardLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

hireCardECardStep2.propTypes = {
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardECard: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
};

module.exports = hireCardECardStep2;
